<template>
  <div>
    <kudos-search v-model="filters" :external="external" class="mb-5" />
    <kudos-list
      :loading="loading"
      :kudos="kudosFiltered"
      :received="received"
      :selectable="selectable"
      :selected="selected"
      @select="$emit('select', $event)"
    >
      <template #tooltip="data">
        <slot name="tooltip" v-bind="data" />
      </template>
    </kudos-list>
  </div>
</template>

<script>
import KudosSearch from './KudosSearch.vue'
import KudosList from './KudosList.vue'
import { KUDO_SELECT_TYPE } from '@/helpers/types'
import { kudosQuery } from '@/helpers/helpers'

export default {
  name: 'KudosSearchList',

  model: {
    prop: 'selected',
    event: 'select'
  },

  props: {
    kudos: {
      type: Array
    },

    received: {
      type: Array
    },

    loading: {
      type: Boolean
    },

    selectable: {
      type: Boolean
    },

    external: {
      type: Boolean
    },

    selected: {
      type: Number
    }
  },

  computed: {
    kudosFiltered() {
      return kudosQuery(this.kudos || [], this.received, this.filters.query, this.filters.type)
    }
  },

  data() {
    return {
      filters: {
        query: '',
        type: KUDO_SELECT_TYPE.ALL
      }
    }
  },

  components: {
    KudosSearch,
    KudosList
  }
}
</script>
